export const ActiveRadioIcon = () => (
  <div className="flex">
    <div className="w-[18px] h-[18px] rounded-full bg-accent-bg-base flex items-center justify-center">
      <div className="w-3 h-3 rounded-full bg-accent-fg-on-accent"></div>
    </div>
  </div>
);

export const InactiveRadioIcon = () => (
  <div className="flex">
    <div className="w-[18px] h-[18px] rounded-full border border-border-base"></div>
  </div>
);
